/** @typedef {3 | 2 | 1 | 0} CoverageTier */

/** @param {number} count @returns {CoverageTier} */
export function tierOf(count) {
	if (count >= 3) return 3;
	if (count === 2) return 2;
	if (count === 1) return 1;
	return 0;
}

export const TIER_DOT_CLASS = {
	3: "monitoring__analysis-strategy-tier-dot--3",
	2: "monitoring__analysis-strategy-tier-dot--2",
	1: "monitoring__analysis-strategy-tier-dot--1",
	0: "monitoring__analysis-strategy-tier-dot--0",
};

export const TIER_BADGE_CLASS = {
	3: "monitoring__analysis-strategy-tier-badge--3",
	2: "monitoring__analysis-strategy-tier-badge--2",
	1: "monitoring__analysis-strategy-tier-badge--1",
	0: "monitoring__analysis-strategy-tier-badge--0",
};

export const TIER_TEXT_CLASS = {
	3: "monitoring__analysis-strategy-tier-text--3",
	2: "monitoring__analysis-strategy-tier-text--2",
	1: "monitoring__analysis-strategy-tier-text--1",
	0: "monitoring__analysis-strategy-tier-text--0",
};

export const TIER_LABEL = {
	3: "3 providers",
	2: "2 providers",
	1: "1 provider",
	0: "Not mentioned",
};
